module.exports = __webpack_public_path__ + "img/trash-plus.9c260e78.svg";